/**
 * Cat Suncatcher PDP helpers:
 * - Default Size to M (Best Seller) when no ?variant= is present
 * - Jump gallery hero/thumbs to Background featured media on option change
 */
(function () {
  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function getVariantSelects() {
    return qs(document, 'variant-selects[data-product-handle="cat-suncatcher"]');
  }

  function setActiveGalleryMedia(sectionId, mediaId) {
    if (!sectionId || !mediaId) return;
    var gallery = qs(document, 'media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
    gallery.setActiveMedia(sectionId + '-' + mediaId, true);
  }

  function syncGalleryFromCheckedBackground(variantSelects) {
    if (!variantSelects) return;
    var sectionId = variantSelects.dataset.section;
    var bgInput = qsa(variantSelects, 'input[type="radio"][data-option-name="Background"]').find(function (el) {
      return el.checked;
    });
    if (!bgInput) return;
    var mediaId = bgInput.getAttribute('data-featured-media-id');
    if (mediaId) setActiveGalleryMedia(sectionId, mediaId);
  }

  function selectDefaultM(variantSelects) {
    if (!variantSelects) return;
    if (new URLSearchParams(window.location.search).has('variant')) return;

    var prefix = variantSelects.dataset.defaultSizePrefix || 'M -';
    var sizeInputs = qsa(variantSelects, 'input[type="radio"][data-option-name="Size"]');
    var mInput = sizeInputs.find(function (el) {
      return String(el.value || '').indexOf(prefix) === 0;
    });
    if (!mInput || mInput.checked || mInput.disabled) return;

    mInput.checked = true;
    mInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function bind(variantSelects) {
    if (!variantSelects || variantSelects.dataset.fondamiaCatBound === 'true') return;
    variantSelects.dataset.fondamiaCatBound = 'true';

    variantSelects.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || target.getAttribute('data-option-name') !== 'Background') return;
      // Immediate hero jump using the option's featured media (before section fetch settles).
      var mediaId = target.getAttribute('data-featured-media-id');
      if (mediaId) setActiveGalleryMedia(variantSelects.dataset.section, mediaId);
    });

    // After Dawn section swap, re-assert Background featured media.
    document.addEventListener('variant:change', function () {
      syncGalleryFromCheckedBackground(variantSelects);
    });

    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () {
        syncGalleryFromCheckedBackground(variantSelects);
      });
    }

    selectDefaultM(variantSelects);
    // Sync gallery once for the (possibly newly selected) Background.
    requestAnimationFrame(function () {
      syncGalleryFromCheckedBackground(variantSelects);
    });
  }

  function init() {
    bind(getVariantSelects());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
